import React from "react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import ConsultForm from "../components/ConsultForm";
import { MapPin, Mail, Phone } from "lucide-react";

export default function Contact() {
  const { t } = useLang();
  const c = t.contactPage;

  const info = [
    { Icon: MapPin, label: c.address, value: c.addressValue },
    { Icon: Mail, label: c.emailLabel, value: c.emailValue },
    { Icon: Phone, label: c.phoneLabel, value: "+971 56 981 8938 / +971 50 751 2496", ltr: true },
  ];

  return (
    <div>
      <PageHero tag={c.hero.tag} title={c.hero.title} desc={c.hero.desc} />
      <section className="py-12">
        <div className="rq-container grid lg:grid-cols-2 gap-10 items-start">
          <Reveal>
            <div>
              <h3 className="font-display text-2xl font-bold text-white">{c.infoTitle}</h3>
              <div className="mt-8 space-y-5">
                {info.map((it, i) => (
                  <div key={i} className="rq-card p-5 flex items-center gap-4">
                    <div className="grid place-items-center h-12 w-12 rounded-xl bg-[rgba(46,230,110,0.12)] text-[color:var(--rq-green)] shrink-0">
                      <it.Icon size={22} />
                    </div>
                    <div>
                      <div className="text-xs text-[color:var(--rq-muted)]">{it.label}</div>
                      <div className="font-semibold text-white whitespace-pre-line" dir={it.ltr ? "ltr" : undefined}>{it.value}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-8 rq-card overflow-hidden h-64">
                <iframe
                  title="map"
                  src="https://www.google.com/maps?q=Al+Rigga+Dubai+UAE&output=embed"
                  className="w-full h-full border-0"
                  loading="lazy"
                />
              </div>
            </div>
          </Reveal>
          <Reveal delay={140}>
            <ConsultForm />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
